import { alpha } from '@mui/material/styles';
import CloseButton from 'components/CloseButton';
import Tooltip from 'components/Tooltip';
import { useBulkCloseScopeControl } from 'features/layout/grid-panel/useBulkCloseScopeControl';

export const BulkCloseContentControl = () => {
  const { enabled, handleClick, label } = useBulkCloseScopeControl('all');

  return enabled ? (
    <Tooltip disableInteractive title={label}>
      <CloseButton
        onClick={handleClick}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          zIndex: 1000,
          color: alpha(theme.palette.common.black, 0.85),
          '&:hover': {
            backgroundColor: alpha(theme.palette.common.black, 0.04),
          },
        })}
      />
    </Tooltip>
  ) : null;
};
